import React, { useState } from 'react';
import {
  VertModal,
  VertContainer,
  VertButton,
  Typography,
} from '@vertem-core/vertice-ds';
import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';
import CircleCheck from 'components/Concierge/Icons/circleCheck';
import { Col, Row } from 'antd';

const ConfirmationRequestModal = ({ isOpen, onClose, numberRequester, isBillPayment }) => {

  return (
    <VertModal
      destroyOnClose={false}
      closable={false}
      open={isOpen}
      onCancel={onClose}
      className="modal-text-align"
    >
      <CircleCheck width={48} height={49} strokeWidth={2.5} className="margin-bottom-divider" />

      <VertContainer className="text-weight-modal-confirmation margin-bottom-divider margin-top-divider">
        <Typography.Title level={2} className='color-title' >
          {
            isBillPayment ?
              <>
                Sua solicitação de pagamento está em análise
              </>
              :
              <>
                Sua solicitação está em análise
              </>
          }
        </Typography.Title>
        <Typography.Text strong className='color-title'>
          {'Nº da solicitação: '}
        </Typography.Text>
        <Typography.Text strong className='color-title'>
          {numberRequester}
        </Typography.Text>
      </VertContainer>

      <Typography.Text >
        {
          isBillPayment ?
            <>
              Para acompanhar o andamento do seu pagamento, fique atento ao seu e-mail. Caso surja qualquer problema, nosso concierge entrará em contato.
            </>
            :
            <>
              Nosso time irá avaliar e você receberá as informações sobre suas solicitações por e-mail.
            </>
        }
      </Typography.Text>

      <Row className='margin-top-divider' justify={"center"}>
        <Col>
          <VertButton
            className='button-continue button-concierge'
            type='highlight'
            size="default"
            onClick={() => onClose()}
          >
            <Typography.Text className='span-button-continue'>
              Entendi
            </Typography.Text>

          </VertButton>
        </Col>
      </Row>

    </VertModal>
  );
};

export default ConfirmationRequestModal;
